











import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScatterGraphInterface } from '@/interfaces/ScatterGraphInterface';
// @ts-ignore
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

// @ts-ignore
FusionCharts.options.creditLabel = false;

// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Charts, FusionTheme);

@Component
export default class ScatterGraph extends Vue {

    @Prop() protected chartData!: ScatterGraphInterface;
    @Prop() protected lineColor!: string;

    protected dataSource = {
        chart: {
            caption: this.chartData.chartCaption,
            xaxisname: this.chartData.xAxisName,
            yaxisname: this.chartData.yAxisName,
            xaxisminvalue: '0',
            xaxismaxvalue: Math.ceil(Math.round(this.chartData.xAxisMaxValue + 1)),
            ynumbersuffix: this.chartData.yNumberSuffix ? this.chartData.yNumberSuffix : '%',
            yaxisminvalue: '0',
            xnumbersuffix: this.chartData.type === 'profitability' ? 'x' : '%',
            theme: 'fusion',
            showlegend: '0',
            plottooltext: '<strong>$xDataValue, $yDataValue</strong>',
            showYAxisLine: true,
            outCnvBaseFontColor: '#354052',
            baseFontColor: '#ffffff',
            toolTipBgColor: '#333f52',
            yAxisNameFontColor: '#333f52',
            xAxisNameFontColor: '#333f52',
            yAxisLineColor: '#f2f2f2',
            toolTipBorderColor: '#333f52',
            captionAlignment: 'left',
            regressionLineThickness: '2',
            anchorBorderThickness: '2',
            anchorRadius: '5',
            anchorBgColor: '#ffffff',
            anchorBorderColor: this.lineColor,
            xAxisNameFontBold: '1',
            yAxisNameFontBold: '1',
        },

        dataset: [
            {
                showregressionline: '1',
                data: this.chartData.data,
            },
        ],
    };

    protected config = {
        type: 'scatter',
        width: '100%',
        height: '400',
        dataFormat: 'json',
    };

}
